// extracted by mini-css-extract-plugin
export default {"page":"BS","headerwrap":"CS","headerblock":"ES","textwrapper":"FS","text":"GS","closerlook":"HS","arrowwrap":"IS","icon":"JS","updown":"KS","products":"LS","system":"MS","systemimage":"NS","cards":"OS","note":"PS","fadein":"QS"};
    if(module.hot) {
      // 1714442370880
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  